import { render, staticRenderFns } from "./DashboardUserInfo.vue?vue&type=template&id=2b404a2e&scoped=true"
import script from "./DashboardUserInfo.vue?vue&type=script&lang=js"
export * from "./DashboardUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b404a2e",
  null
  
)

export default component.exports